export interface MessageListStyles {
  style?: React.CSSProperties;
  messageStyle?: React.CSSProperties;
}

export const styles: MessageListStyles = {
  style: {},
  messageStyle: {},
};
